import { render, staticRenderFns } from "./virtual-payment-list-title.vue?vue&type=template&id=08d1d13a&scoped=true"
import script from "./virtual-payment-list-title.vue?vue&type=script&lang=js"
export * from "./virtual-payment-list-title.vue?vue&type=script&lang=js"
import style0 from "./virtual-payment-list-title.vue?vue&type=style&index=0&id=08d1d13a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1d13a",
  null
  
)

export default component.exports